import { compareAsc, parse } from "date-fns";

// Keeps each series to the latest 30 update timestamps across all series.
// A series without a value at some timestamp simply has no point there:
// charts show a gap instead of a fake drop to zero.
export function fillEmptyDates(data) {
  if (Array.isArray(data)) {
    const allDates = new Set(
      Array.from(
        new Set(data.flatMap((series) => series.data.map((point) => point.x)))
      )
        .map((dateStr) => ({
          dateStr,
          date: parse(dateStr, "dd-MM-yyyy HH:mm", new Date()),
        }))
        .sort((a, b) => compareAsc(a.date, b.date))
        .slice(-30)
        .map(({ dateStr }) => dateStr)
    );

    return data.map((series) => ({
      ...series,
      data: series.data.filter((point) => allDates.has(point.x)),
    }));
  }
}
